module.exports = __webpack_public_path__ + "static/img/2.08f499c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/2.png
// module id = rath
// module chunks = 0